const heroCta = document.getElementById('hero-cta');
const stickyCta = document.getElementById('sticky-cta');

if (heroCta && stickyCta) {
  const observer = new IntersectionObserver(
    (entries) => {
      const heroVisible = entries[0].isIntersecting;
      stickyCta.classList.toggle('sticky-cta--hidden', heroVisible);
      stickyCta.classList.toggle('sticky-cta--visible', !heroVisible);
    },
    { threshold: 0 }
  );

  observer.observe(heroCta);
}
